import { render, staticRenderFns } from "./Penthouse.vue?vue&type=template&id=431638e1&scoped=true&"
import script from "./Penthouse.vue?vue&type=script&lang=js&"
export * from "./Penthouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431638e1",
  null
  
)

export default component.exports